/** `tasks` namespace — Swedish (source of truth). */
const tasks = {
  priority: {
    low: 'Låg',
    normal: 'Normal',
    high: 'Hög',
  },
  board: {
    column: {
      todo: 'Att göra',
      inProgress: 'Pågående',
      review: 'Granska',
      done: 'Klara',
    },
    syncing: 'Synkar uppgifter...',
    addTask: 'Ny uppgift',
  },
  fields: {
    title: 'Titel',
    titlePlaceholder: 'Uppgiftstitel...',
    description: 'Beskrivning',
    describePlaceholder: 'Beskriv uppgiften...',
    addDescriptionPlaceholder: 'Lägg till beskrivning...',
    priority: 'Prioritet',
    assign: 'Tilldela',
    assignees: 'Tilldelade',
    assigneePlaceholder: 'Välj person...',
    noAssignee: 'Ingen',
    board: 'Tavla',
    dueDate: 'Förfallodatum',
    pickDate: 'Välj datum...',
    clearDueDate: 'Rensa förfallodatum',
    tags: 'Taggar',
    tagPlaceholder: 'Lägg till tagg och tryck Enter...',
    removeTag: 'Ta bort taggen {{tag}}',
    subtasks: 'Deluppgifter',
  },
  create: {
    title: 'Ny uppgift',
  },
  panel: {
    newTask: 'Ny uppgift',
    task: 'Uppgift',
    details: 'Uppgiftens detaljer',
    close: 'Stäng',
    expand: 'Expandera panelen',
    collapse: 'Förminska panelen',
    attachments: 'Bilagor ({{count}})',
    documents: 'Dokument',
    upload: 'Ladda upp',
    download: 'Ladda ner',
    openDocument: 'Öppna dokument',
    deleteAttachment: 'Ta bort bilaga',
    sourceChats: 'Källchattar ({{count}})',
    newChat: 'Ny chatt',
    comments: 'Kommentarer ({{count}})',
    commentPlaceholder: 'Skriv en kommentar...',
    send: 'Skicka',
    deleteComment: 'Ta bort kommentar',
    confirmDelete: 'Ta bort uppgiften?',
    confirmDeleteYes: 'Ja, ta bort',
    deleteTask: 'Ta bort uppgift',
    cancel: 'Avbryt',
    create: 'Skapa',
  },
  assignee: {
    placeholder: 'Tilldela...',
    selected_one: '{{count}} tilldelad',
    selected_other: '{{count}} tilldelade',
    search: 'Sök person...',
    noMatches: 'Inga träffar',
  },
  subtasks: {
    progress: '{{completed}}/{{total}} klara',
    assign: 'Tilldela',
    none: 'Ingen',
    addPlaceholder: 'Lägg till deluppgift...',
    delete: 'Ta bort deluppgift',
  },
}

export default tasks
